import { EFilterUsersActions } from '../actions/filter-user.actions';

export const initialFilterUsersState: IFilterUsersState = {
    isLoadingColumns: false,
    isLoadingUsers: false,
    users: [],
    filterColumns: []
}

export function filterUsersReducers (state = initialFilterUsersState, action: any): IFilterUsersState {
  switch (action.type) {
    case EFilterUsersActions.GetFilterColumns: {
        const newState = {
          ...state,
          isLoadingColumns: true
        };
        return newState;
      }
    case EFilterUsersActions.GetFilterColumnsSuccess: {
      const newState = {
        ...state,
        isLoadingColumns: false,
        filterColumns: action.payload
      };
      return newState;
    }

    case EFilterUsersActions.FilterUsers: {
        const newState = {
          ...state,
          isLoadingUsers: true
        };
        return newState;
      }
    case EFilterUsersActions.FilterUsersSuccess: {
      const newState = {
        ...state,
        isLoadingUsers: false,
        users: action.payload
      };
      return newState;
    }

    default:
      return state;
  }
};

export const getAutocompleteUsers = (state: IFilterUsersState) => state.users;
export const getFilterColumns = (state: IFilterUsersState) => state.filterColumns;
export const isLoadingUsers = (state: IFilterUsersState) => state.isLoadingUsers;